module.exports = __webpack_public_path__ + "changelog-4-6041afd778e517c5cc958f94d19f5883.webp";